import { FeatureCollection } from 'geojson'
import { get } from 'lodash'
import { get3dBoundaryStyle, StyleOptions } from 'map-style-utils'
import { Layer, LayerProps } from 'ms-map-gl'
import { FC, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { BoundaryClickPlugin } from '~map-preview/App/Map/Plugins/FeatureClickPlugin/Boundary'
import { useLayerType } from '~map-preview/states/layerType'
import { setLegend } from '~map-preview/states/legend'

type BoundaryLayerProps = {
  geojson: FeatureCollection
  boundaryStyleOptions: StyleOptions
}

export const Boundary3DLayer: FC<BoundaryLayerProps> = (props) => {
  const { boundaryStyleOptions, geojson } = props
  const dispatch = useDispatch()
  const layerType = useLayerType()

  const boundaryStyle = useMemo(
    () =>
      // INFO: -1 is the default elevation
      get3dBoundaryStyle(geojson, -1, boundaryStyleOptions),
    [geojson, boundaryStyleOptions]
  )

  useEffect(() => {
    boundaryStyle.legend && dispatch(setLegend(boundaryStyle.legend))
  }, [boundaryStyle, dispatch, layerType])

  const interactionLayer = get(boundaryStyle?.fill, 'id', undefined)

  return (
    <>
      {boundaryStyle?.fill && (
        <Layer {...(boundaryStyle?.fill as LayerProps)} />
      )}

      {boundaryStyle.line && <Layer {...(boundaryStyle?.line as LayerProps)} />}

      {interactionLayer && (
        <BoundaryClickPlugin
          layer={interactionLayer}
          geojson={geojson}
        />
      )}
    </>
  )
}
